import React from 'react';
import styled from 'styled-components';
import styles from './ToastPopup.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

function ToastPopup({ message, show }) {
  // console.log({ message, show });
  return (
    <div className={cx('ToastPopup')}>
      <div className={`toast-wrap-body ${show ? 'show' : ''}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="20px"
          height="20px"
        >
          <path d="M0 11c2.761.575 6.312 1.688 9 3.438 3.157-4.23 8.828-8.187 15-11.438-5.861 5.775-10.711 12.328-14 18.917-2.651-3.766-5.547-7.271-10-10.917z" />
        </svg>
        <p className={'toast-text'}>{message}</p>
      </div>
    </div>
  );
}

export default ToastPopup;
